/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'gh-gantt-confirm-delete-dialog',
  template: require('./gantt-confirm-delete-dialog.component.html'),
  styles: [require('./gantt-confirm-delete-dialog.component.scss')],
})
export class GanttConfirmDeleteDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<GanttConfirmDeleteDialogComponent>,
  ) {
  }

  close(): void {
    this.dialogRef.close();
  }
  apply(): void {
    this.dialogRef.close('delete');
  }
}
